import { connection } from '../../utils/connection';
import { AUTH_URL } from '../../config/config';

async function signupService({ token, params }) {
    return await connection({ method: 'POST', url: `${AUTH_URL.COMPLETE_SIGNUP}`, params: params, extraHeaders: { token: token } });
}

export default signupService;
